import { fetchWrapper } from "../../../fetchWrapper";

const formatDateToYYYYMMDD = (date) => {
  if (!date) return "";
  return new Date(date).toISOString().split("T")[0];
};

//Recibe el arreglo de filtros con sus respectivos valores para convertirlos en una url usada para la peticion
const getPerFilter = async (
  pageIndex,
  pageSize,
  filters,
  Table,
  activity_id,
  exportExcel,
  viewListActivity,
  upload_id,
  category_id
) => {
  try {
    let url = `/${Table}/${Table}_per_filter?page=${pageIndex}&pageSize=${pageSize}`;
    if (activity_id) {
      url += `&activity_id=${activity_id}`;
    }
    if (upload_id) {
      url += `&upload_id=${upload_id}`;
    }
    if (category_id) {
      url += `&category_id=${category_id}`;
    }
    if (exportExcel) {
      url += `&exportExcel=${exportExcel}`;
    }
    if (viewListActivity === 0 || viewListActivity === 1) {
      url += `&viewListActivity=${viewListActivity}`;
    }
    if (filters && Array.isArray(filters)) {
      filters.forEach((filter) => {
        if (
          filter.type !== "expires_in" &&
          filter.type !== "created" &&
          filter.type !== "created_at" &&
          filter.type !== "updated_at" &&
          filter.type !== "fecha" &&
          filter.type !== "modified" &&
          filter.type !== "processed_at"
        ) {
          url += `&type_filter[]=${encodeURIComponent(filter.type)}&search[]=${encodeURIComponent(filter.value)}`;
        } else if (
          filter.type === "expires_in" ||
          filter.type === "created" ||
          filter.type === "created_at" ||
          filter.type === "updated_at" ||
          filter.type === "fecha" ||
          filter.type === "modified" ||
          filter.type === "processed_at"
        ) {
          const fromDate = formatDateToYYYYMMDD(filter.value.from);
          const untilDate = formatDateToYYYYMMDD(filter.value.until);
          url += `&type_date[]=${encodeURIComponent(filter.type)}&dateFrom[]=${encodeURIComponent(fromDate)}&dateUntil[]=${encodeURIComponent(untilDate)}`;
        }
      });
    }

    const result = await fetchWrapper(
      process.env.REACT_APP_BACKEND_URL + "/filter" + url,
      { method: "GET" },
      false,
      true // returnRawResponse = true para manejar tanto JSON como Excel
    );

    return result;
  } catch (error) {
    console.error("getPerFilter error:", error);
    const message = "Error del servidor al realizar la solicitud";
    return { success: false, message: error.message || message };
  }
};

//Recibe el arreglo de filtros con sus respectivos valores para convertirlos en una url usada para la peticion
const getPerFilterPerFile = async (id, pageIndex, pageSize, filters, Table) => {
  const idFileOrDataSourceId = Table === "cards" ? "file_id" : "per_data_source";
  try {
    let url = `/${Table}/${Table}_per_filter_${idFileOrDataSourceId}/${id}?page=${pageIndex}&pageSize=${pageSize}`;
    if (filters && Array.isArray(filters)) {
      filters.forEach((filter) => {
        if (
          filter.type !== "expires_in" &&
          filter.type !== "created" &&
          filter.type !== "created_at" &&
          filter.type !== "updated_at"
        ) {
          url += `&type_filter[]=${encodeURIComponent(filter.type)}&search[]=${encodeURIComponent(filter.value)}`;
        } else if (
          filter.type === "expires_in" ||
          filter.type === "created" ||
          filter.type === "created_at" ||
          filter.type === "updated_at"
        ) {
          url += `&type_date[]=${encodeURIComponent(filter.type)}&dateFrom[]=${encodeURIComponent(filter.value.from)}&dateUntil[]=${encodeURIComponent(filter.value.until)}`;
        }
      });
    }

    const response = await fetch(process.env.REACT_APP_API_URL + url);
    const result = await response.json();
    const { success, code } = result;
    if (success === true) {
      const {
        payload: { data, last_page, total, from, to },
      } = result;
      return { data, last_page, total, from, to, success };
    } else if (success === false) {
      const message = "Error del servidor al realizar la solicitud";
      const status = false;
      return { status, message };
    }
  } catch (error) {
    const message = "Error del servidor al realizar la solicitud";
    const status = false;
    return { status, message };
  }
};

export { getPerFilter, getPerFilterPerFile };
